/**
 * Created by stonewang on 2017/8/15.
 */
import React from 'react';
import Reflux from 'reflux';
import {regionStore,regionActions} from './store';
import { hashHistory,withRouter } from 'react-router';
import {Icon, Button, Menu, Dropdown,message} from 'antd';
import {DmsTab, TableView, FilterBox} from 'Components';
import {regionList,regionModify,regionDelete} from '../../service/region';

class RegionList extends Reflux.Component {
	constructor(props) {
		super(props);
		this.store = Reflux.initStore(regionStore);
		this.state = {
			opts: ['地区管理'],
			key: 0,
			filterBoxVisible: false,
			rows: [],
			total: 0,
			selectedKeys:[],
			searchObj: {
				regionName: '',
				regionCode: '',
				active:null,
				p:1,
				s:10
			}
		};
		
		this.pageChange = this.pageChange.bind(this);
		this.visibleChange = this.visibleChange.bind(this);
		this.setFilterParam = this.setFilterParam.bind(this);
		this.advanceReset = this.advanceReset.bind(this);
		this.advanceSubmit = this.advanceSubmit.bind(this);
		this.dropdownClick = this.dropdownClick.bind(this);
		this.goView=this.goView.bind(this);
		this.getData=this.getData.bind(this);
		this.routeLeaveHook=this.routeLeaveHook.bind(this);
	}
	
	
	//离开当前路由时，更新store
	routeLeaveHook(nextLocation) {
		const {searchObj} =this.state;
		let path = nextLocation.pathname.split('/');
		let regionId=nextLocation.query.regionId;
		if(path[1] === 'region' && path[2] === 'regionadd'&&regionId){ //当下一个路由是详情页时，将useStore的值设为true
			regionActions.useStoreChange(true);
			regionActions.paramChange(searchObj);
		}else{
			regionActions.useStoreChange(false);
			regionActions.paramChange({});
		}
	}
	
	componentWillMount () {
		const data = this.store.state;
		if (data.useStore) { //根据useStore的值判断是否使用store中的数据
			this.setState({
				searchObj:data.storeData
			});
		}
	}
	
	componentDidMount(){
		this.getData();
		this.props.router.setRouteLeaveHook(this.props.route, this.routeLeaveHook);
	}
	
	//请求数据列表
	getData(){
		var obj=this.state.searchObj;
		regionList(obj).then(result=>{
			if(result.status){
				let regionList=result.data;
				this.setState({
					rows:regionList,
					total:result.total
				})
			}else{
				message.error(result.message);
			}
		})
	}
	
	
	//页面跳转
	goView (url) {
		hashHistory.push(url);
	}
	
	visibleChange() {
		this.setState({filterBoxVisible: !this.state.filterBoxVisible});
	}
	
	advanceReset() {
		const self = this;
		this.setState({
			filterBoxVisible: !this.state.filterBoxVisible,
			searchObj: {
				...this.state.searchObj,
				regionName: '',
				regionCode: '',
				active:null,
				p: 1
			}
		}, () => {
			self.getData();
		});
	};
	
	advanceSubmit(form) {
		var submitObj=this.state.searchObj;
		submitObj.p=1;
		//有效性选择
		
		submitObj.active = submitObj.active || null;
		
		const self = this;
		this.setState({
			filterBoxVisible: !this.state.filterBoxVisible,
			searchObj: submitObj}, function () {
			self.getData();
		});
	};
	
	setFilterParam(name, value) {
		this.setState({searchObj: {...this.state.searchObj, [name]: value}});
	};
	
	pageChange(page, pageSize) {
		const self = this;
		this.setState({ searchObj: { ...this.state.searchObj, s: pageSize, p: page } }, function () {
			self.getData();
		});
	}
	
	onVisibleChange(visible){
		this.setState({
			selectedKeys:[]
		});
	}
	
	dropdownClick({item, key, keyPath}) {
		const {selectedKeys} =this.state;
		selectedKeys.push(key);
		this.setState({
			selectedKeys
		});
		var arr = key.split('_');
		if (arr[0] === '0') {
			var regionId=this.state.rows[arr[1]].regionId;
			window.location.assign('#/region/regionadd?regionId=' + regionId);
		}
		if (arr[0] === '1') {//有效变无效
			var changeObj=this.state.rows[arr[1]];
			if(changeObj.active===0){
				changeObj.active=1;
			}else{
				changeObj.active=0;
			}
			regionModify(changeObj).then(result => {
				if (result.status) {
					message.success(result.message);
					this.getData();
				}else{
					message.error(result.message);
				}
			})
		};
		if (arr[0] === '2') {//删除
			regionDelete(parseInt(this.state.rows[arr[1]].regionId,0)).then(result=>{
				if(result.status){
					message.success(result.message);
					this.getData();
				}else{
					message.error(result.message);
				}
			})
		};
	}
	
	menu(index) {
		return <Menu
			style={{width: "100px", textAlign: 'center'}}
			onClick={this.dropdownClick}
			selectedKeys={this.state.selectedKeys}>
			<Menu.Item key={`0_${index}`}>
				编辑
			</Menu.Item>
			<Menu.Item key={`1_${index}`}>
				{
					this.state.rows[index].active===1?
						'失效'
						:
						'有效'
				}
			</Menu.Item>
			<Menu.Item key={`2_${index}`}>
				删除
			</Menu.Item>
		</Menu>
	}
	
	render() {
		const {opts, filterBoxVisible, rows, total,searchObj} = this.state;
		const filterBoxProps = {
			showFlag: filterBoxVisible,
			advance: {
				fileds: [
					{
						name: 'regionName',
						label: '地区名称',
						defaultValue:searchObj.regionName,
						text: '请输入地区名称',
						type: 'default'
					},
					{
						name: 'id',
						label: '地区编码',
						defaultValue:searchObj.regionCode,
						text: '请输入地区编码',
						type: 'default'
					}
				],
				handle: this.advanceSubmit,
				reset: this.advanceReset,
				fieldHandle: this.setFilterParam
			}
		};
		const tableViewProps = {
			loading: false,//更新表格数据中
			rowKey: 'regionId',
			pageParam: {
				total,
				current: searchObj.p,//当前页码
				pageSize: searchObj.s,//当前分页数
				onChange: this.pageChange
			},
			columns: [{
				title: '名称',
				dataIndex: 'regionName',
				render: text => <span>{text}</span>,
			}, {
				title: '编码',
				dataIndex: 'id',
			}, {
				title: '创建时间',
				dataIndex: 'createdDate',
                render:(text)=> {
                    var dates = new Date(text);
                    return dates.format('yyyy-MM-dd hh:mm:ss')
                }
			}, {
				title: '更新时间',
				dataIndex: 'lastUpdatedDate',
				render:(text)=> {
					var dates = new Date(text);
					return dates.format('yyyy-MM-dd hh:mm:ss')
				}
			},
				{
					title: '更多操作',
					key: 'action',
          			className: 'alignCenter',
					render: (text, record, index) => (
						<Dropdown
							overlay={this.menu(index)}
							placement='bottomCenter'
							trigger={['click']}
							onVisibleChange={this.onVisibleChange.bind(this)}
						>
							<span className="ant-dropdown-link">
								<Icon type="caret-down"/>
							</span>
						</Dropdown>
					)
				}],
			rows
		};
		return (
			<div className='dms-body'>
				<div>
					<DmsTab options={opts} defaultKey={0} onChange={this.changeHandle}>
						<Button icon="plus" onClick={this.goView.bind(this, '/region/regionadd')}>新增</Button>
						<Button icon="filter" onClick={this.visibleChange}>筛选</Button>
						<FilterBox  {...filterBoxProps}/>
					</DmsTab>
				</div>
				
				<div className="dms-table-box">
					<TableView {...tableViewProps} />
				</div>
			</div>
		)
	}
};
export default withRouter (RegionList);




// WEBPACK FOOTER //
// ./src/routes/region/list.js